import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from "../../../app/_services/app.service";
import { environment } from "../../../environments/environment";
import { Helpers } from "../../helpers";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-view-invoice',
  templateUrl: './view-invoice.component.html',
  styleUrls: ['./view-invoice.component.scss']
})
export class ViewInvoiceComponent implements OnInit {
  selectedLang: string;
  PrintData: any = [];
  RoundOfAmount: any = 0;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyGSTCode: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any;
  datatable: any;
  DashboardData: any = {};
  IsAuthorized: any = false;
  IsPosted: any = false;
  selectedCard: string = "Draft";
  isInternational: boolean = false;
  ReceiptSummaryData: any = [];
  JVSummaryData: any = [];
  ShowAttachment: any = false;
  hostUrl: any = environment.apiUrl;
  hostDomainUrl: any = environment.apiUrl;
  dataid: any;
  static that: ViewInvoiceComponent;
  bookingId
  type

  //add vithujan 26-07-2022
  PrintDataModal: any = {};
  //end

  constructor(private _appService: appService, private service: TranslateConfigService,
    private translate: TranslateService, private route: ActivatedRoute, private router: Router, private toastr: ToastrService,) {
    ViewInvoiceComponent.that = this;
    let language = 'en';
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage('en');
      this.selectedLang = 'en';
    }
    let val = localStorage.getItem(LNG_KEY);

  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.dataid = this.route.snapshot.queryParams.id;
      // this.type = this.route.snapshot.queryParams["Detail"];
      this.GetPrintData(this.dataid, "Detail");
    });

  }

  GetPrintData(Id, Type) {
    Helpers.setLoading(true);
    //add vithujan 26-07-2022
    this.PrintDataModal.InvoiceId = Id;
    this.PrintDataModal.Type = Type == 'Detail1OnLatterPad' ? 'Detail1' : Type;

    // this._appService.GetByTwoId("Sales", "GetPrintData", Id, Type == 'Detail1OnLatterPad' ? 'Detail1' : Type).subscribe(
    this._appService.Post("Sales", "GetPrintData", this.PrintDataModal).subscribe((response) => {

      this.PrintData = response;
      for (var i = 0; i < this.PrintData.length; i++) {
        let SGST: any = 0.0;
        let CGST: any = 0.0;
        let IGST: any = 0.0;

        this.PrintData[i].TotalQty = 0;
        this.PrintData[i].TotalDiscount = 0;
        this.PrintData[i].TotalAmount = 0;
        this.PrintData[i].NetTotalAmount = 0;
        this.PrintData[i].RoundOffValue = 0;
        this.PrintData[i].TotalCGST = 0;
        this.PrintData[i].TotalSGST = 0;
        this.PrintData[i].TotalIGST = 0;

        let UBSrNo = 1;

        this.PrintData[i].InvoiceDetails.forEach((element) => {
          //-----for Ub only------------
          if (Type == "AllInOne") {
            if (element.Unit == "Day") {
              element.SrNo = UBSrNo;
              UBSrNo++;
            }
          }
          //----------------------------
          if (
            element.Discount == null ||
            element.Discount == undefined ||
            element.Discount == ""
          ) {
            element.Discount = 0;
          }
          if (this.PrintData[i].IsTaxable == true) {
            if (element.CGST != null && element.CGST != 0) {
              CGST = element.Amount * (element.CGST / 100);
            }
            if (element.SGST != null && element.SGST != 0) {
              SGST = element.Amount * (element.SGST / 100);
            }
            if (element.IGST != null && element.IGST != 0) {
              IGST = element.Amount * (element.IGST / 100);
            }
          } else {
            element.ChargedGST = "NA";
          }

          this.PrintData[i].TotalAmount += element.Amount;
          this.PrintData[i].TotalDiscount += element.Discount;
          this.PrintData[i].TotalQty += element.Quantity;
          this.PrintData[i].TotalQty =
            Math.round(this.PrintData[i].TotalQty * 100) / 100;

          this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));
          this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));
          this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));
          CGST = 0.0;
          SGST = 0.0;
          IGST = 0.0;
        });

        this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));
        this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));
        this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));
        this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));
        this.PrintData[i].NetTotalAmount =
          this.PrintData[i].TotalAmount +
          this.PrintData[i].TotalCGST +
          this.PrintData[i].TotalSGST +
          this.PrintData[i].TotalIGST;
        this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));
        // add kevin 12-Jan-2022
        this.RoundOfAmount = parseFloat((Math.round(this.PrintData[i].NetTotalAmount) - this.PrintData[i].NetTotalAmount).toFixed(2));
        this.PrintData[i].NetTotalAmount = Math.round(this.PrintData[i].NetTotalAmount);
        this.PrintData[i].RoundOffValue = this.RoundOfAmount;
        // end
        this.PrintData[i].TotalTaxablevalue = 0;
        this.PrintData[i].ComponentToTalIGST = 0;
        this.PrintData[i].ComponentToTalSGST = 0;
        this.PrintData[i].ComponentToTalCGST = 0;
        this.PrintData[i].ComponentToTalGST = 0;
        if (Type != "AllInOne") {
          this.PrintData[i].ComponentRate.forEach((element) => {
            element.ComponentGST = 0;
            // console.log('isTaxable', this.InvoiceData.IsTaxable);
            if (this.PrintData[i].IsTaxable != true) {
              element.IntegratedGST = 0;
              element.StateGST = 0;
              element.CentralGST = 0;
              element.IGSTRATE = 0;
              element.SGSTRATE = 0;
              element.CGSTRATE = 0;
            }
            this.PrintData[i].TotalTaxablevalue += element.TaxableValue;
            this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;
            this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;
            this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;
            element.ComponentGST +=
              element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;
          });
          this.PrintData[i].ComponentToTalGST =
            this.PrintData[i].ComponentToTalIGST +
            this.PrintData[i].ComponentToTalSGST +
            this.PrintData[i].ComponentToTalCGST;
        } else {
          this.PrintData[i].TotalDamage = 0;
          this.PrintData[i].TotalShortage = 0;
          this.PrintData[i].TotalSealShort = 0;
          this.PrintData[i].TotalGoodQtyBoxes = 0;
          this.PrintData[i].TotalGoodQtyBottles = 0;

          this.PrintData[i].InvoiceProductDetail.forEach((element) => {
            //--------------------Bottles---------------------
            let TotalBottles = element.Quantity * 12;
            let TotalGoodBottles =
              TotalBottles -
              (element.Damage + element.Shortage + element.SealShort);
            let TotalGoodQuantityBoxes: number = 0;
            TotalGoodQuantityBoxes = TotalGoodBottles % 12;
            element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;
            //--------------------Boxes-----------------------
            let DamageBoxes = Math.floor(TotalGoodBottles / 12);
            element.TotalGoodQuantityBoxes = DamageBoxes;
            //----------------------Total---------------------

            this.PrintData[i].TotalDamage =
              this.PrintData[i].TotalDamage + element.Damage;
            this.PrintData[i].TotalShortage =
              this.PrintData[i].TotalShortage + element.Shortage;
            this.PrintData[i].TotalSealShort =
              this.PrintData[i].TotalSealShort + element.SealShort;
            this.PrintData[i].TotalGoodQtyBoxes =
              this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;
            this.PrintData[i].TotalGoodQtyBottles =
              this.PrintData[i].TotalGoodQtyBottles +
              element.TotalGoodQuantityBottles;
          });
        }
        if (Type == "AllInOne") {
          this.PrintData[i].TotalHaltingAmount = 0.0;
          this.PrintData[i].TotalProductQuantity = 0;
          this.PrintData[i].InvoiceDetails.forEach((element) => {
            if (element.Unit == "Day") {
              this.PrintData[i].TotalHaltingAmount =
                this.PrintData[i].TotalHaltingAmount + element.Amount;
            }
          });
          this.PrintData[i].InvoiceProductDetail.forEach((element) => {
            this.PrintData[i].TotalProductQuantity =
              this.PrintData[i].TotalProductQuantity + element.Quantity;
          });
        }
      }

      if (Type == "Summary") {
        this.PrintSummary();
      } else if (Type == "Detail") {
        this.PrintDetail();
      }
    },
      (err) => {
        this.toastr.error("An error occured printing !", "error");
      }
    );
  }

  PrintSummary() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummary");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;

      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintDetail() {
    setTimeout(() => {

      var divElements = document.getElementById("PrintDetail");
      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

}
